import { EntityName } from '@provision/entity-types';

export enum UserPresenceStatus {
  active = 'active',
  inactive = 'inactive',
}

export type UserPresence = {
  userId: string;
  status: UserPresenceStatus;
  tz: string;
  ts: number;
  assigneeGroups: { id: string; name: string }[];
  lastSeen: number; // epoch sec
  expiresAt: number; // epoch sec
  updatedAt: number; // epoch ms
};

export type GetUserPresenceResult = {
  getUserPresence: {
    entity: EntityName;
    entityId: string;
    items: UserPresence[];
    ts: number;
  };
};

export type UpdateUserPresenceVars = {
  params: {
    entity: EntityName;
    entityId: string;
    partnerId: number;
    status: UserPresenceStatus;
    firstName?: string;
    lastName?: string;
  };
};
